import type { LuggageTypeEntry, SpecialLuggageBaseValues } from '../engine/types'
import { DECIMAL_INPUT_PATTERN } from '@/scopes/common/components/FormElements/utils/decimalPatternUtils'

export interface GenericValues extends SpecialLuggageBaseValues {
  height: string
  width: string
  length: string
  weight: string
  termsAndConditions: boolean
}

export interface GenericEntryLinks {
  termsAndConditions?: string
}

export function createGenericEntry({ links }: { links?: GenericEntryLinks } = {}): LuggageTypeEntry<GenericValues> {
  const { termsAndConditions = '' } = links ?? {}

  return {
    schema: {
      defaultValues: {
        height: '',
        width: '',
        length: '',
        weight: '',
        termsAndConditions: false,
      },
      sections: [
        {
          id: 'measureHelpText',
          fields: [
            {
              kind: 'paragraph',
              messageKey: 'booking_details_special_luggage_measure_help_text',
            },
          ],
        },
        {
          id: 'dimensionsRow1',
          layout: 'row',
          fields: [
            {
              kind: 'text',
              name: 'width',
              labelKey: 'booking_details_special_luggage_width_label',
              required: true,
              requiredErrorKey: 'booking_details_special_luggage_dimensions_required_error',
              pattern: DECIMAL_INPUT_PATTERN,
              patternErrorKey: 'booking_details_special_luggage_numeric_pattern_error',
            },
            {
              kind: 'text',
              name: 'height',
              labelKey: 'booking_details_special_luggage_height_label',
              required: true,
              requiredErrorKey: 'booking_details_special_luggage_dimensions_required_error',
              pattern: DECIMAL_INPUT_PATTERN,
              patternErrorKey: 'booking_details_special_luggage_numeric_pattern_error',
            },
          ],
        },
        {
          id: 'dimensionsRow2',
          layout: 'row',
          fields: [
            {
              kind: 'text',
              name: 'length',
              labelKey: 'booking_details_special_luggage_length_label',
              required: true,
              requiredErrorKey: 'booking_details_special_luggage_dimensions_required_error',
              pattern: DECIMAL_INPUT_PATTERN,
              patternErrorKey: 'booking_details_special_luggage_numeric_pattern_error',
            },
            {
              kind: 'text',
              name: 'weight',
              labelKey: 'booking_details_special_luggage_weight_label',
              required: true,
              requiredErrorKey: 'booking_details_special_luggage_dimensions_required_error',
              pattern: DECIMAL_INPUT_PATTERN,
              patternErrorKey: 'booking_details_special_luggage_numeric_pattern_error',
            },
          ],
        },
        {
          id: 'termsAndConditions',
          fields: [
            {
              kind: 'checkbox',
              name: 'termsAndConditions',
              labelKey: 'booking_details_special_luggage_terms_and_conditions_label',
              validationMessageKey: 'booking_details_special_luggage_terms_and_conditions_required_error',
              links: {
                termsAndConditionsLink: {
                  labelKey: 'booking_details_special_luggage_terms_and_conditions_link_label',
                  href: termsAndConditions,
                },
              },
            },
          ],
        },
      ],
    },
  }
}
